import { render, staticRenderFns } from "./OrgColumn.vue?vue&type=template&id=3071f539&scoped=true&"
import script from "./OrgColumn.vue?vue&type=script&lang=js&"
export * from "./OrgColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3071f539",
  null
  
)

export default component.exports